export enum SiteWhiteLabelAgent {
    NAV_MAYA = "agent-nav-maya-big",
    NAV_ALYA = "agent-nav-alya-big",
    NAV_REMI = "agent-nav-remi-big",
    NAV_NOX = "agent-nav-nox-big",
    NAV_MARC = "agent-nav-marc-big",
    NAV_LUCA = "agent-nav-luca",
    NAV_LOUISE = "agent-nav-louise-big",
    NAV_JULE = "agent-nav-jule",
    NAV_CHRIS = "agent-nav-chris",
    NAV_MAX = "agent-nav-max",
    NAV_MULTI = "agent-nav-multi-big",

    AGENT_MAYA = "agent-maya",
    AGENT_ALYA = "agent-alya",
    AGENT_REMI = "agent-remi",
    AGENT_NOX = "agent-nox",
    AGENT_MARC = "agent-marc",

    AGENT_BOTTOM_MAYA = "agent-bottom-maya",
    AGENT_BOTTOM_REMI = "agent-bottom-remi",

    AGENT_GOOGLE_REMI = "agent-google-remi",
    AGENT_WIN_ALYA = "agent-win-alya",

    AGENT_TEAM_WHITE = "agent-team-white",
    AGENT_TEAM = "agent-team",
    AGENT_TEAM_TINY = "agent-team-tiny"
}
